// Pick from the item's tasks an entry to be added to the logbook.

import { useParams, useNavigate } from "react-router-dom";
import { useStatusMessage } from '../../components';
import { copyTaskToCompletedTasks } from '../../utilities/Database.mjs';
import { TaskTable } from '../task/TaskTable';
import { useTaskQuery } from '../task/TaskQuery';
import { bucketNameAll } from '../../fleet-shared/Urls.mjs';
import { SortOverdue } from '../task/Tasks.jsx';
import { urlForLogbookEntryFromTask } from '../../fleet-shared/Urls.mjs';
import { ItemBreadcrumbs } from '../item/ItemBreadcrumbs';
import { useState } from "react";

export const LogbookPickTask = () => {
  const { itemId, logbookId } = useParams();
  const navigate = useNavigate();
  const [item, setItem] = useState(null);
  const [entries, setEntries] = useState(null);

  const fetchItems = useTaskQuery(itemId, bucketNameAll, SortOverdue, setItem);

  const [StatusMessage, {showText, showError}] = useStatusMessage();

  async function taskClicked(task) {
    try {
      showText('Adding');

      // Add entry to database, tied to this logbook.
      let newTask = await copyTaskToCompletedTasks(task, item, logbookId);

      // Navigate to the page to edit the entry.
      navigate(urlForLogbookEntryFromTask(itemId, logbookId, newTask.id));
    } catch (err) {
      showError(err);
    }
  }


  return (
    <div className="container pt-2">
      <div className="card">
        <div className="card-header text-center">
          <ItemBreadcrumbs item={item} />

          <StatusMessage/>

          <h3>Choose a Task to add to the Logbook</h3>

          <TaskTable
            fetchItems={fetchItems}
            onTaskClicked={taskClicked}
            entries={entries}
            setEntries={setEntries}
            tasksListBucket={bucketNameAll}
          />
        </div>
      </div>
    </div>
  );
}

export default LogbookPickTask;
